(() => {
  const root = document.querySelector('[data-reading-product]');
  if (!root) return;
  const form = root.querySelector('[data-reading-form]');
  const selector = form.querySelector('[name="id"]');
  const variants = JSON.parse(root.querySelector('[data-reading-variants]').textContent);
  const quantity = form.querySelector('[name="quantity"]');
  const submit = form.querySelector('[type="submit"]');
  const image = root.querySelector('#productImage');
  const thumbnails = [...root.querySelectorAll('[data-product-thumbnail]')];
  const setImage = (src, alt, width, height) => {
    if (!image || !src) return;
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.src = src;
    image.alt = alt;
    if (width && height) { image.width = width; image.height = height; }
    thumbnails.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.imageSrc === src)));
  };
  selector.addEventListener('change', () => {
    const variant = variants.find((item) => String(item.id) === selector.value);
    if (!variant) return;
    root.querySelector('#displayed_price').textContent = variant.price;
    root.querySelector('[data-product-availability]').textContent = variant.available ? '' : 'Currently sold out';
    submit.disabled = !variant.available;
    submit.textContent = variant.available ? (submit.dataset.availableLabel || 'Add reading to cart') : 'Sold out';
    quantity.min = variant.minimum;
    quantity.step = variant.increment;
    if (variant.maximum != null) quantity.max = variant.maximum;
    else quantity.removeAttribute('max');
    quantity.value = variant.minimum;
    setImage(variant.image, variant.imageAlt, variant.imageWidth, variant.imageHeight);
    // Keep the normal Shopify form and change event available to booking integrations.
    if (variant.url) history.replaceState(null, '', variant.url);
  });
  thumbnails.forEach((button) => {
    button.addEventListener('click', () => {
      setImage(button.dataset.imageSrc, button.dataset.imageAlt, button.dataset.imageWidth, button.dataset.imageHeight);
    });
  });
  document.querySelectorAll('[data-book-review-open]').forEach(button => {
    const modal = document.getElementById(button.dataset.bookReviewOpen);
    if (!modal) return;
    let previousOverflow = '';
    button.addEventListener('click', () => {
      previousOverflow = document.body.style.overflow;
      modal.showModal();
      document.body.style.overflow = 'hidden';
    });
    modal.querySelector('[data-book-review-close]').addEventListener('click', () => modal.close());
    modal.addEventListener('click', event => { if (event.target === modal) modal.close(); });
    modal.addEventListener('close', () => {
      document.body.style.overflow = previousOverflow;
      button.focus();
    });
  });
})();
